<template>
    <v-card flat v-if="products && products.length">
        <v-card-title class="primary-transparent-5 title">
            <span>{{ 'This product is also available in the Deluxe-Version!' | translation }}</span>

            <v-spacer/>

            <v-icon>swap_vertical_circle</v-icon>
        </v-card-title>

        <template v-for="(product, index) in products">
            <related-products-thumbnail
                class="px-2 py-3"
                :key="`product-upgrade-${product.id}`"
                :product="product"
                target="Upgrades Products"
                @beforeAddToBasket="beforeAddToBasket"
                hide-amount-input
                :initial-quantity="getBasketItem(product.id).quantity"
                basket-button-text="Update product"
            />

            <v-divider :key="`product-upgrade-divider-${product.id}`"/>
        </template>
    </v-card>
</template>

<script>
import ProductThumbnailSmall from '@breakmedia/prime-vue-product/src/ProductThumbnailSmall';
import merge from 'lodash/merge';
import {getProducts} from '@breakmedia/prime-vue-product/src/store/getProducts';
import {Observable} from 'rxjs';

const name = 'UpgradesProducts';

export default {
    name: name,
    props: [
        'basketItemsProductIds'
    ],
    components: {
        ProductThumbnailSmall,
    },
    data() {
        return {
            products: [],
            productsSubscriber: null,
        };
    },
    created() {
        this.productsSubscriber = getProducts(new Observable(
            subscriber => this.$watch('productIds', ids => subscriber.next({ids}), {immediate: true})
        )).subscribe(products => this.products = products);
    },
    beforeDestroy() {
        this.productsSubscriber.unsubscribe();
    },
    computed: {
        productIds() {
            let productIds = [];

            Object.values(this.basketItemsProductIds).forEach((ids) => {
                merge(productIds, ids);
            });

            return productIds;
        },
    },
    methods: {
        beforeAddToBasket(item) {
            this.$basket.removeBasketItemLocally(this.getBasketItem(item.product_id));
        },
        getBasketItem(productId) {
            for (let basketItemHash of Object.keys(this.basketItemsProductIds)) {
                if (this.basketItemsProductIds[basketItemHash].indexOf(productId) !== -1) {
                    return this.$basket.getBasketItem(basketItemHash);
                }
            }
        },
    },
};
</script>